import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { RealexTabState } from './RealexTab.state';
import { MultiDepositSteps } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/multiDepositJourney/MultiDepositSteps.state';
import { RealexFrame } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/realexProvider/realexFrame/RealexFrame';
import { DepositTabWrapper } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/DepositProcedure.style';
import { useCommon } from 'src/domains/common/Common';
import { DepositErrorMessagesState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/errorMessages/DepositErrorMessages.state';
import { RealexLoaderWrapper } from './RealexTab.style';

interface RealexTabPropsType {
    amount: string;
    stepsState: MultiDepositSteps;
    isSignup: boolean;
    errorMessagesState: DepositErrorMessagesState;
}

export const RealexTab = observer(
    'RealexTab',
    ({ amount, stepsState, isSignup, errorMessagesState }: RealexTabPropsType): JSX.Element => {
        const common = useCommon();
        const [realexState] = useState(
            () => new RealexTabState(common, amount, stepsState, isSignup, errorMessagesState)
        );

        if (realexState.isLoading === false) {
            return (
                <DepositTabWrapper>
                    <RealexFrame
                        formActionUrl={realexState.formActionUrl}
                        formData={realexState.formData}
                        onMessage={realexState.onMessage}
                    />
                </DepositTabWrapper>
            );
        }

        return (
            <DepositTabWrapper>
                <RealexLoaderWrapper size={12} />
            </DepositTabWrapper>
        );
    }
);
